import { apiClient } from "@/services/apiClient";

export type FeedbackStatus = "new" | "read" | "resolved";

export interface FeedbackListItem {
  id: string;
  tenantId: string;
  tenantName: string;
  userId: string;
  userEmail: string;
  userName: string | null;
  message: string;
  status: FeedbackStatus;
  createdAt: string;
}

export interface ListFeedbackResponse {
  data: FeedbackListItem[];
  total: number;
  page: number;
  limit: number;
}

export function getFeedbackList(
  page: number,
  limit: number,
  status?: FeedbackStatus
): Promise<ListFeedbackResponse> {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (status) params.set("status", status);
  return apiClient
    .get<ListFeedbackResponse>(`/platform/feedback?${params.toString()}`)
    .then((res) => res.data);
}

export function updateFeedbackStatus(
  id: string,
  status: FeedbackStatus
): Promise<void> {
  return apiClient
    .patch(`/platform/feedback/${id}`, { status })
    .then(() => undefined);
}
